import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { UpdateOrderDeliveryAddressComponent } from '../update-order-delivery-address/update-order-delivery-address.component';

import { Order } from '@api/order/order.models';

@Component({
    selector: 'update-order-shipping',
    templateUrl: './update-order-shipping.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        TranslateModule,
        UpdateOrderDeliveryAddressComponent,
    ],
})
export class UpdateOrderShippingComponent implements OnInit {
    private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);

    public order!: Order;

    public ngOnInit(): void {
        this.order = this.activatedRoute.snapshot.data.order;
    }
}
